import {DatePipe} from '@angular/common';
import {AfterViewInit, Component, ElementRef, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntryType, ModalTypes, QuestionType, RouterLinks, Superflow} from '../../constants';
import {Question, ShoppingCartItem} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {QuestionFlowSessionStore} from '../state/question-flow-session.store';
import {ShoppingCartQuery} from '../state/shopping-cart-query';
import {ShoppingCartStore} from '../state/shopping-cart-store';
import {ModalService} from '../../services/modal.service';
import {SidebarService} from '../../services/sidebar-service';
import {UserStore} from '../../../authentication/state/user.store';
import {ClaimsService} from '../../../claim/services/claims.service';

declare var $: any;

@Component({
    selector: 'app-question-claim-summary-update',
    templateUrl: './question-claim-summary-update.component.html',
    styleUrls: ['./question-claim-summary-update.component.scss'],
    standalone: false
})
export class QuestionClaimSummaryUpdateComponent implements OnInit, AfterViewInit {

  @Input() question: Question;

  questions: Question[] = [];
  childrenQuestions: Question[] = [];
  input_cart_item: any = {};
  loading = false;
  groups: any[] = [];
  claim_name: string;
  event_details: any;
  session_details: any;
  date: any;
  address: any;
  isSavingData = false;
  QuestionType = QuestionType;
  ModalTypes = ModalTypes;
  modal_type: ModalTypes;
  cart_item: ShoppingCartItem;
  police_report: ShoppingCartItem;
  shoppingCartItems: any[] = [];

  constructor(
    private globalQuestionService: GlobalQuestionService,
    private sidebarService: SidebarService,
    private datePipe: DatePipe,
    private sessionQuery: QuestionFlowSessionQuery,
    private sessionStore: QuestionFlowSessionStore,
    private userStore: UserStore,
    private claimsService: ClaimsService,
    private shoppingCartQuery: ShoppingCartQuery,
    private shoppingCartStore: ShoppingCartStore,
    private router: Router,
    private modalService: ModalService,
    private el: ElementRef) {
  }


  ngOnInit(): void {
    this.session_details = this.sessionQuery.getValue();

    // category_id can end up 0 here even with a real session_id (whatever started/resumed this
    // claim flow didn't carry it through) - every downstream call (getQuestionGrouping, shopping
    // cart, etc.) reads category_id off this same shared store, so recover it before using it
    // rather than silently sending 0.
    if (!this.session_details?.category_id && this.session_details?.session_id) {
      this.resumeMissingCategoryId(this.session_details.session_id);
    } else {
      this.populateSidebar();
    }

    this.modalService.claimsEditModalMobileModalObservable
      .subscribe(x => {
        if (x) {
          $('#modal-submenu').modal('show');
        } else {
          $('#modal-submenu').modal('hide');
        }
      });
  }

  resumeMissingCategoryId(session_id: string): void {
    const person_id = this.userStore.getValue()?.person_id;
    this.claimsService.getClaims(person_id, session_id).subscribe({
      next: (claims: any[]) => {
        const claim = claims?.[0];
        if (claim?.product_category_id) {
          this.sessionStore.update({
            category_id: claim.product_category_id,
            css: claim.category_class,
            flow_id: 14,
            superflow_id: Superflow.personal_claim
          });
          this.session_details = this.sessionQuery.getValue();
        }
        this.populateSidebar();
      },
      error: () => this.populateSidebar()
    });
  }

  ngAfterViewInit(): void {
    const activeItem = this.shoppingCartQuery.getActive();
    if (activeItem) {
      this.input_cart_item = activeItem;
    } else {
      if (!this.input_cart_item) {
        this.input_cart_item = this.getEventDetailsItem();
      } else {
        if (Object.keys(this.input_cart_item).length === 0) {
          this.input_cart_item = this.getEventDetailsItem();
        }
      }
    }

    this.activateItem(this.input_cart_item);
  }

  back(): void {
    this.router.navigate([`/${RouterLinks.ClaimSummary}`]);
  }

  getItemStatus(progress: any, hasskipped: any): string {
    if (progress < 1) {
      return 'pending';
    } else {
      if (hasskipped === 1) {
        return 'pending';
      } else {
        return 'complete';
      }
    }
  }

  onRemoveItemChange(value: any): void {
    if (value?.item?.class_id && value?.item?.item_id) {
      this.removeItem(value?.item?.class_id, value?.item?.item_id);
    }
  }

  removeItem(class_id: any, item_id: string): void {
    if(class_id === 0 || item_id === '0') return;
    this.globalQuestionService.spinner(true);
    const session_details = this.sessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('product_class_id', class_id);
    parameters.set('item_id', item_id);
    this.globalQuestionService.runCommandNew('removeItem', parameters)
      .subscribe(x => {
        this.populateSidebar();
      });
  }

  getEventDetailsItem(): any {
    return this.event_details?.items[0];
  }

  populateSidebar(): any {
    this.groups = [];
    this.event_details = null;

    this.globalQuestionService.getShoppingCart(0)
    .subscribe((shoppingCartItems: ShoppingCartItem[]) => {

      if (!shoppingCartItems?.length) {
        this.globalQuestionService.spinner(false);
        return;
      }

      //console.log(shoppingCartItems)
      this.shoppingCartStore.set(shoppingCartItems);

      //const activeItem = shoppingCartItems?.find(f => f?.entry_type === 'event_details');

      // if(activeItem){
      //   this.shoppingCartStore.setActive(activeItem.shoppingcart_id);
      //   this.activateItem(activeItem);
      // }



      const cartItems = shoppingCartItems;

      const groupsDict: {} = cartItems?.reduce((r: any, a: any) => {
        r[a.class_id] = [...r[a.class_id] || [], a];
        return r;
      }, {});

      const groupsArray = Object.entries(groupsDict);
      console.log(groupsArray)
      groupsArray?.forEach((item: any) => {
        let items = [];
        const entries = item[1];

        entries?.forEach((entry: any) => {
          const stageName = entry.entry_type;

          let status = 'inactive';
          if (entry.active === 1) {
            status = 'active';
          }
          if (entry.progress === 1) {
            status = 'complete';
          }
          switch (stageName) {
            case 'event_details':
              items = [];
              const event_description = entry?.description?.split('|');
              if (event_description) {
                const name = event_description[0];
                const dateSplit = event_description[2]?.split('-');
                let date: any;
                let location: any;

                if (dateSplit) {
                  const year = dateSplit[0];
                  const month = dateSplit[1];
                  const day = dateSplit[2];
                  const startDate = new Date(+year, +month - 1, +day);
                  date = this.datePipe.transform(startDate, 'MMM dd, yyyy');
                }

                if (event_description[1]) {
                  const address = JSON.parse(event_description[1]);
                  location = `${address.streetAddress}, ${address.suburb}, ${address.city}, ${address.postalCode}`;
                }

                items.push({name, location, date, shoppingcart_id: entry?.shoppingcart_id, entry_type: entry.entry_type, item_id: entry.item_id, flow_id: entry.flow_id, class_id: entry.class_id});
                this.claim_name = name;
              }
              const ev_group = {group_type: this.getEntryType('event_details_header')[0]?.description, entry_type: stageName, items, status, percentage: `${entry.progress * 100}%`};
              this.event_details = ev_group;
              break;
            case 'class_header':
              items = this.getItemsByClassId(entries, entry.class_id);
              const class_group = {group_type: stageName, group_class: entry.class_id, group_name: entry.class_name, items, status, percentage: `${entry.progress * 100}%`};
              this.groups.push(class_group);
              break;
            case 'police_report_details':
              this.police_report = entry;
              break;
            default:
              break;
          }
        });
      });

      this.globalQuestionService.spinner(false);
    });




  }

  getEntryType(entry_type: string): any {
    const cartItems = this.shoppingCartQuery.getAll();

    return cartItems.filter((entry: any) =>
      entry.entry_type === entry_type);
  }

  getItemsByClassId(entries: any[], class_id: number): any {
    return entries?.filter(entry => entry.entry_type === 'class_item' && entry.class_id === class_id);
  }

  formatItemDescription(description: string, type: number): string {
    const splitDescription = description?.split('|');
    if (splitDescription) {
      switch (type) {
        case 1:
          return splitDescription[0];
        case 2:
          return splitDescription[1];
        default:
          return '';
      }
    }
    return '';
  }

  activateItem(item: any): any {
    this.shoppingCartStore.setActive(item?.shoppingcart_id);
    this.cart_item = item;
    console.log(this.cart_item)
    switch (item.entry_type) {
      case EntryType.event_details:
        this.modal_type = ModalTypes.event_details;
        break;
      case EntryType.class_item:
        this.modal_type = ModalTypes.item_details;
        break;
      case EntryType.police_report_details:
        this.modal_type = ModalTypes.police_report_details;
        break;
      default:
        this.modal_type = ModalTypes.none;
        break;
    }
    this.modalService.setClaimsEditModalMobileModalSubject(false);
  }

  populateSideColl(): void {
    this.globalQuestionService.getShoppingCart(this.question?.cent_aq_question_id)
      .subscribe((summary: any[]) => {
        const event_details = summary.find((entry: any) => entry.entry_type === 'event_details');

        const event_description = event_details?.description?.split('|');
        if (event_description) {
          this.claim_name = event_description[0];

          const dateSplit = event_description[2]?.split('/');
          const year = dateSplit[2];
          const month = dateSplit[1];
          const day = dateSplit[0];

          const startDate = new Date(+year, +month - 1, +day);
          this.date = this.datePipe.transform(startDate, 'MMM dd, yyyy');

          if (event_description[1]) {
            try {
              const address = JSON.parse(event_description[1]);
              this.address = `${address.streetAddress}, ${address.suburb}, ${address.city}, ${address.postalCode}`;
            } catch {
              // event_description[1] wasn't valid address JSON - leave address blank rather than crash
            }
          }
        }
      });
  }

  getResponses(class_id: any, item_id: any): any {
    this.globalQuestionService.getResponses()
      .subscribe(r => {
        let questions: Question[];
        questions = r;

        if (questions?.length) {
          this.questions = [];
          this.childrenQuestions = [];
        }

        for (const q of questions) {
          if (q.answer && q?.item_id?.toString() === item_id?.toString() && q?.product_class_id?.toString() === class_id?.toString()) {
            if (q?.parent_control) {
              this.childrenQuestions.push(q);
              const parentQuestion = questions.find(x => x?.cent_aq_question_id === q?.parent_control);
              if (parentQuestion && !this.questions?.some(x => x.cent_aq_question_id === parentQuestion?.cent_aq_question_id)) {
                this.questions.push(parentQuestion);
              }
            } else {
              if (!this.questions?.some(x => x?.cent_aq_question_id === q?.cent_aq_question_id)) {
                this.questions.push(q);
              }
            }
          }
        }
        this.loading = false;
      });
  }

  closeSubModal(): void {
    this.modalService.setClaimsEditModalMobileModalSubject(false);
  }


}
